import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { MarketSegmentModel } from "../models/settings/market-segment.model";
import { TenantModel } from "../models/tenants/tenant.model";
import { TenantTypeModel } from "../models/tenants/tenant-type.model";

@Injectable({
  providedIn: 'root'
})
export class TenantContextService {
  private tenantSubject = new BehaviorSubject<TenantModel | null>(null);
  public tenant$ = this.tenantSubject.asObservable();

  public setTenant(tenant: TenantModel): void {
    this.tenantSubject.next(tenant);
  }

  public getTenant(): TenantModel | null {
    return this.tenantSubject.value;
  }

  public getMarketSegment(): MarketSegmentModel | null {
    const tenant = this.getTenant();
    return tenant?.segment ?? null;
  }

  public getTenantType(): TenantTypeModel | null {
    const tenant = this.getTenant();
    return tenant?.type ?? null;
  }

  public getCreatedByTenantId(): string | null {
    const tenant = this.getTenant();
    return tenant?.createdByTenantId ?? null;
  }

  public getTenantId(): string | null {
    const tenant = this.getTenant();
    return tenant?.id ?? null;
  }

  public getLoginAlias(): string | null {
    const tenant = this.getTenant();
    return tenant?.loginAlias ?? null;
  }

  public isIndividualBrokerTenant(): boolean {
    const tenantType = this.getTenantType();
    const isIndividualBroker = tenantType === TenantTypeModel.Individual;
    return isIndividualBroker;
  }

  public isBrokerPoolTenant(): boolean {
    const tenantType = this.getTenantType();
    const isBrokerPool = tenantType === TenantTypeModel.BrokerPool;
    return isBrokerPool;
  }

  public getCertificateFontSettings(): { 
    fontFamily: string | null; 
    fontSize: string | null 
  } {
    const tenant = this.getTenant();

    return {
      fontFamily: tenant?.certificateFontFamily ?? null,
      fontSize: tenant?.certificateFontSize ?? null
    };
  }
}